import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import { Building, Calendar, Download, RefreshCw } from "lucide-react";

// import PDCOpenPopup from "./PDCOpenPopup";
import axios from "axios";
// import PDCReportPrint from "./PDCReportPrint";

import PDCReportPrint from "../PDCDirectory/PDCReportPrint";

const DeliveryOrderReports = () => {
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  const roles = [
    { id: "value-1", label: "Delivery Order List", mode: "DELIVERYLIST" },
    { id: "value-2", label: "Delivery Order (invoiced)", mode: "DOINVOICED" },
    { id: "value-3", label: "Delivery Pending", mode: "DOPENDING" },
    { id: "value-4", label: "Delivery Items Pending", mode: "DOPENDINGITEM" },
    { id: "value-5", label: "Delivery Items Invoiced", mode: "DOINVOICEDITEM" },
  ];

  const newDate = new Date();
  const today = newDate.toISOString().split("T")[0];
  const [selectedToggle, setSelectedToggle] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [amounts, setAmounts] = useState([]);
  const [transferDate, setTransferDate] = useState(null);
  const [openPDC, setOpenPDC] = useState(false);
  const [selected, setSelected] = useState("value-1");
  const [selectedMod, setSelectedMod] = useState("PDC_R");
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState(today);
  const [salesmanList, setSalesmanList] = useState([]);
  const [banks, setBanks] = useState([]);
  const [bankName, setBankName] = useState("");
  const [includeChecked, setIncludeChecked] = useState(false);
  const [isPDCReportPrint, setIsPDCReportPrint] = useState(false);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [doList, setDOList] = useState([]);
  const [ty, setTy] = useState("DELIVERYLIST");
  const [sgroup, setSGroup] = useState("-");
  const [sperson, setSperson] = useState("-");
  const [scategory, setScategory] = useState("-");
  const [sDept, setSdept] = useState("-");

  const [groupList, setGroupList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [salesPersonList, setSalesPersonList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  useEffect(() => {
    callSalesPersonListAPI();
    fetchDepartments();
    fetchMasterList("GROUP", setGroupList);
    fetchMasterList("CATEGORY", setCategoryList);
    fetchCompanyInfo();
    fetchDOList();
  }, []);

  useEffect(() => {
    fetchDOList();
  }, [ty]);

  const callSalesPersonListAPI = () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const currentDepartmentFromLocalStorage = localStorage.getItem(
      "currentSelectedDepartment",
    );
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setSalesPersonList(res.data);
      })
      .catch((err) => {});
  };

  const fetchDepartments = async () => {
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const apiURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/DEPTLIST/-/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      console.log("Dept List:", data);
      setDepartmentList(data);
    } catch (error) {
      console.error("Error while fetching Dept list!", error);
    }
  };

  const fetchMasterList = async (type, setter) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let url = `${apiPaths[0]?.API_CONFIG}/api/MasterCount/${companyCode}/${type}/-/-`;

    try {
      const response = await axios.get(url);
      console.log("responseeee:", response.data);
      setter(response.data || []);
      console.log("data::", [type, response.data]);
    } catch (err) {
      console.error("Error while loading Voucher Type List:", err);
    }
  };

  const fetchCompanyInfo = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/COMPANYINFO/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      const companyInfoData = data[0];
      console.log("companyInfoData :", companyInfoData);
      setStartDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));

      // setToDate(dayjs(companyInfoData.ftend).format("YYYY-MM-DD"))
    } catch (err) {
      console.error("Error while fetching companny Info", err);
    }
  };

  const fetchDOList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMDeliveryAnalysis/${COMPANY_CODE}/${ty}/-/-/-/${startDate}/${endDate}/${sgroup}/-/${scategory}/-/${sDept}/-/-/-/${sperson}/-`;

    try {
      const res = await axios.get(apiUrl);
      setDOList(res.data || []);
    } catch (error) {
      console.error("Error fetching bank list:", error);
    }
  };

  const handleExport = () => {
    const columns = [
      { field: "TYPE", headerName: "Type" },
      { field: "DEPTNO", headerName: "Department No" },
      { field: "DONO", headerName: "Delivery Order No" },
      { field: "DATE", headerName: "Date" },
      { field: "CUSTOMER", headerName: "Customer" },
      { field: "LPO", headerName: "LPO" },
      { field: "AMOUNT", headerName: "Amount" },
      { field: "VAT", headerName: "VAT" },
      { field: "AMOUNT_EXCLVAT", headerName: "Amount Excl. VAT" },
      { field: "INV NO", headerName: "Invoice No" },
      { field: "SALESMAN", headerName: "Salesman" },
    ];

    exportToCSV(columns, doList, "Delivery_Order_Reports");
  };

  const exportToCSV = (columns, exportData, exportFileName = "export") => {
    if (!columns || !exportData || exportData.length === 0) return;

    const headerRow = columns.map((col) => col.headerName);

    const dataRows = exportData.map((row) =>
      columns.map((col) => {
        let value = row[col.field] ?? "";

        if (col.field === "CHQDATE" && value) {
          value = dayjs(value).format("DD/MM/YYYY");
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      }),
    );

    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${exportFileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="">
      <div className="my-4 mx-6">
        <h2 className="text-xl text-gray-800 mb-4">Delivery Order Reports</h2>
      </div>
      <div className="flex justify-center items-start">
        <div className="w-[26vw] h-[77vh] bg-gradient-to-br from-slate-50 via-white to-slate-50 shadow border-r border-slate-200 p-3 flex flex-col">
          <div className="flex-1 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-slate-300">
            {/* Role Selection - Custom Radio */}
            <div className="">
              <div className="bg-gray-100 py-4 px-2 rounded-md space-y-3 ">
                {roles.map((role) => (
                  <label
                    key={role.id}
                    className={`
        relative flex items-center gap-4 px-4 h-12 rounded-xl cursor-pointer
        border-2 transition-all duration-300 ease-out
        ${
          selected === role.id
            ? "bg-gradient-to-r from-green-500 to-green-600 border-green-500 shadow scale-[1.01]"
            : "bg-white border-slate-200 hover:border-slate-300 hover:shadow hover:scale-[0.99]"
        }
      `}
                  >
                    <input
                      type="radio"
                      name="value-radio"
                      value={role.id}
                      checked={selected === role.id}
                      onChange={() => {
                        setTy(role.mode);
                        setSelected(role.id);
                        setSelectedMod(role.id);
                      }}
                      className="sr-only"
                    />

                    {/* Custom Radio Circle */}
                    <div
                      className={`
          w-5 h-5 rounded-full flex items-center justify-center transition-all duration-200
          ${selected === role.id ? "bg-white" : "bg-slate-300"}
          ${selected === role.id ? "ring-4 ring-green-400 ring-opacity-30" : ""}
        `}
                    >
                      <div
                        className={`
            w-2 h-2 bg-green-600 rounded-full transition-transform duration-200
            ${selected === role.id ? "scale-100" : "scale-0"}
          `}
                      />
                    </div>

                    <p
                      className={`text-sm transition-colors ${
                        selected === role.id ? "text-white" : "text-slate-700"
                      }`}
                    >
                      {role.label}
                    </p>

                    {/* Pulse on select */}
                    {selected === role.id && (
                      <div className="absolute inset-0 rounded-xl bg-green-400 opacity-0" />
                    )}
                  </label>
                ))}
              </div>

              <div className="flex justify-center items-center gap-1 ">
                {/* <div className="">
                            <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                              <ArrowUpRight className="w-4 h-4 mr-2 text-gray-600" />
                              Bank
                            </label>
                            <input
                              value={crAccount}
                              onChange={(e) => setCrAccount(e.target.value)}
                              placeholder="Enter Cr A/C..."
                              className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                                 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 
                                 placeholder-gray-400 transition-all duration-200"
                            />
                          </div> */}
                <div className=" w-full my-2">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                    From Date
                  </label>
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                                 focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                                 transition-all duration-200"
                  />
                </div>

                <div className="w-full">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                    To Date
                  </label>
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                                 focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                                 transition-all duration-200"
                  />
                </div>
              </div>

              <div className="flex justify-left items-center gap-1 my-4">
                <div className="flex-1">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Building className="w-4 h-4 mr-2 text-gray-600" />
                    Group
                  </label>
                  <select
                    value={sgroup}
                    onChange={(e) => setSGroup(e.target.value)}
                    className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 placeholder-gray-400 transition-all duration-200"
                  >
                    <option value="">Select Group...</option>
                    {groupList.map((grp, index) => (
                      <option key={index} value={grp["GRP CODE"]}>
                        {grp.DESCRIPTION}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex-1">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Building className="w-4 h-4 mr-2 text-gray-600" />
                    Category
                  </label>
                  <select
                    value={scategory}
                    onChange={(e) => setScategory(e.target.value)}
                    className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 placeholder-gray-400 transition-all duration-200"
                  >
                    <option value="">Select Category...</option>
                    {categoryList.map((cat, index) => (
                      <option key={index} value={cat["GRP CODE"]}>
                        {cat.DESCRIPTION}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="flex justify-left items-center gap-1 my-4">
                <div className="flex-1">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Building className="w-4 h-4 mr-2 text-gray-600" />
                    Salesperson
                  </label>
                  <select
                    value={sperson}
                    onChange={(e) => setSperson(e.target.value)}
                    className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 placeholder-gray-400 transition-all duration-200"
                  >
                    <option value="">Select Salesperson...</option>
                    {salesPersonList.map((sperson, index) => (
                      <option key={index} value={sperson.EMP_ID}>
                        {sperson.NAME}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex-1">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Building className="w-4 h-4 mr-2 text-gray-600" />
                    Department
                  </label>
                  <select
                    value={sDept}
                    onChange={(e) => setSdept(e.target.value)}
                    className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 placeholder-gray-400 transition-all duration-200"
                  >
                    <option value="">Select Department...</option>
                    {departmentList.map((dept, index) => (
                      <option key={index} value={dept.deptno}>
                        {dept.deptnodesc}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {/* Action Buttons: Print & Export */}
            <div className="flex gap-3 py-2">
              <button
                onClick={fetchDOList}
                className="flex-1 flex items-center justify-center gap-2 
                                   bg-teal-500 text-white 
                                   font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
                                   transform hover:scale-[1.02] active:scale-100 
                                   transition-all duration-200 text-sm"
              >
                <RefreshCw className="w-4 h-4" />
                Apply
              </button>

              <button
                onClick={handleExport}
                disabled={!doList || doList.length === 0}
                className={`flex-1 flex items-center justify-center gap-2 
    font-medium px-4 py-2.5 rounded-lg text-sm
    transition-all duration-200
    ${
      !doList || doList.length === 0
        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
        : "bg-cyan-600 text-white shadow hover:shadow-md transform hover:scale-[1.02] active:scale-100"
    }
  `}
              >
                <Download className="w-4 h-4" />
                Export
              </button>
            </div>
          </div>
        </div>
        <div className="w-full h-[77vh] overflow-auto shadow">
          <table className="relative text-xs border-collapse w-full">
            <thead>
              <tr>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Type
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Dept No
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  DO No
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Date
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Customer
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  LPO
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 text-right">
                  Amount
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 text-right">
                  VAT
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 text-right">
                  Amount Excl VAT
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Invoice No
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Salesman
                </th>
              </tr>
            </thead>

            <tbody>
              {doList?.length > 0 ? (
                doList.map((row, index) => (
                  <tr key={index} className="text-xs">
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.TYPE ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.DEPTNO ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.DONO ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.DATE ? dayjs(row.DATE).format("DD/MM/YYYY") : "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-left">
                      {row?.CUSTOMER ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.LPO ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {row?.AMOUNT ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {row?.VAT ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {row?.AMOUNT_EXCLVAT ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.["INV NO"] ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.SALESMAN ?? "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={11} className="text-center py-4 text-gray-500">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* {isPDCReportPrint && (
          <div className="m-6">
            <PDCReportPrint
              pdcReportPrintDataFromAPI={accounts}
              setIsPDCReportPrint={setIsPDCReportPrint}
              isPDCReportPrint={isPDCReportPrint}
            />
          </div>
        )} */}
      </div>
    </div>
  );
};

export default DeliveryOrderReports;

// https://cubixweberp.com:213/api/CRMDeliveryAnalysis/DOODDEMO/DELIVERYLIST/-/-/-/2025-01-01/2025-12-01/-/-/-/-/-/-/-/-/-/-
// https://cubixweberp.com:213/api/CRMDeliveryAnalysis/DOODDEMO/DELIVERYLIST/-/-/-/2025-12-22/2025-12-22/-/-/-/-/-/-/-/-/-/-
